// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__lIAxu","Secondary":"Button_Secondary__6mi+Q","Small":"Button_Small__owFms","Buttonloader":"Button_Buttonloader__HclHd","spin":"Button_spin__vHmqK"};